import { c as _c } from "react/compiler-runtime";
import IconFavoriteDisable from '@/components/assets/icon_favorite_disable.svg';
import IconFavoriteEnable from '@/components/assets/icon_favorite_enable.svg';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
function formatLikesCount(count: number) {
  if (count <= 0) {
    return undefined;
  }
  const table = [{
    limit: 1_000_000,
    unitKey: 'million'
  }, {
    limit: 1_000,
    unitKey: 'kilo'
  }, {
    limit: 1,
    unitKey: ''
  }];
  for (const row of table) {
    if (count >= row.limit) {
      let num = count / row.limit;
      num = Math.floor(num * 10) / 10;
      let result = num.toString();
      if (result.length >= 5 && result.includes('.')) {
        result = Math.floor(num).toString();
      }
      return {
        count: result,
        unitKey: row.unitKey
      };
    }
  }
}
function CommentLikeButton(t0) {
  const $ = _c(21);
  const {
    isLiked,
    handleClick,
    likeCount
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== likeCount) {
    t1 = formatLikesCount(likeCount);
    $[0] = likeCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const likesCount = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "34px",
      height: "34px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isLiked ? "opacity-100" : "opacity-0";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("group-hover:[&>path]:fill-vive-white absolute inset-0 m-auto group-hover:opacity-100", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <IconFavoriteEnable className={t4} width={20} height={20} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isLiked ? "opacity-0" : "opacity-100";
  let t7;
  if ($[7] !== t6) {
    t7 = cn("absolute inset-0 m-auto group-hover:opacity-0", t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <IconFavoriteDisable className={t7} width={20} height={20} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== handleClick || $[12] !== t5 || $[13] !== t8) {
    t9 = <button onClick={_temp}><div className="group relative" style={t2} onClick={handleClick}>{t5}{t8}</div></button>;
    $[11] = handleClick;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== likesCount || $[16] !== t) {
    t10 = likesCount && <span className="flx-col buttonS-omni-styles flex items-center leading-4.5">{likesCount.count}{likesCount.unitKey && t(`comment-block.likes-unit.${likesCount.unitKey}`)}</span>;
    $[15] = likesCount;
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="flex h-8.5 w-fit min-w-[80px] items-center">{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp(prev) {
  return !prev;
}
export default CommentLikeButton;